import { ComponentType, ElementType, createElement } from "react";
import { IconBaseProps, IconType } from "react-icons";
import { FaClock, FaLocationArrow } from "react-icons/fa";

export const routeMetricIcons = { time: FaClock, distance: FaLocationArrow };

export type IconComponent = ComponentType<IconBaseProps>;

export function renderIcon(
  Icon: IconComponent | IconType | ElementType | undefined,
  className?: string
) {
  if (!Icon) return null;
  return createElement(Icon as ElementType, { className });
}
